const CategoryTabs = (props) => (
  <div className='category-edit_container--tabs'>
    {
      props.tabs.map((tab, index) => (
        <span
          className={`category-edit_container--tab ${tab.toLowerCase().replace(' ', '-')} ${props.activeTab === index ? 'active-tab' : ''}`}
          onClick={() => props.onCallback(index)}>
          { tab }
        </span>
      ))
    }
  </div>
)

export default CategoryTabs
